export default [
    {
      path: '/grabCoupon/index',
      meta:{
        title: '327爱吃节'
      },
      component: (resolve) => require(['@/pages/grabCoupon/index'], resolve)
    }
  ]
  